import { AccessTime, Cached, SvgIconComponent } from '@mui/icons-material'
import { Chip, ChipProps, Tooltip } from '@mui/material'
import { AMENDMENT_STATE_COLOR, AmendmentState } from './amendmentStates'

const STATE_ICON: Record<AmendmentState, SvgIconComponent> = {
  'awaiting-change': AccessTime,
  'change-required': Cached,
  'change-actioned': Cached,
  changed: Cached,
}

type AmendmentStateChipProps = {
  state: AmendmentState
  label: string
  tooltipLabel?: string
  iconSx?: ChipProps['sx']
  sx?: ChipProps['sx']
  'data-testid'?: string
}

// The amendment chip every surface delegates to — icon and colour are bound to the state here,
// so surfaces only supply their own copy.
export const AmendmentStateChip = ({
  state,
  label,
  tooltipLabel,
  iconSx,
  sx,
  'data-testid': dataTestId,
}: AmendmentStateChipProps) => {
  const Icon = STATE_ICON[state]
  const chip = (
    <Chip
      size="small"
      label={label}
      icon={<Icon sx={iconSx} />}
      color={AMENDMENT_STATE_COLOR[state]}
      data-testid={dataTestId}
      data-amendment-state={state}
      sx={sx}
    />
  )
  return tooltipLabel == null ? chip : <Tooltip title={tooltipLabel}>{chip}</Tooltip>
}
